import * as FLAGS from 'country-flag-icons/react/3x2'
import { FC } from 'react'

/**
 * * Icon Component for: Country Flags
 */
type CountryFlagIconProps = {
  code: string
  size?: number
}
export const CountryFlagIcon: FC<CountryFlagIconProps> = ({ code, size = 20 }) => {
  const FlagIcon = FLAGS[code]
  if (!FlagIcon) {
    return null
  }
  return <FlagIcon width={size} height={size} />
}
